export const childrenNumber = (() => {
  const numberList = [];

  for (let i = 1; i < 9; i++) {
    numberList.push({
      value: i,
      label: i.toString(),
    });
  }

  return numberList;
})();
